export default "__VITE_ASSET__SpWmf9pW__"